<template>
  <section id="redirect">
    <div>
      <img src="@/assets/imgs/rings.svg" alt="Loading..." />
      <p>Estamos processando a informação.</p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'login-syscor',
  data: () => ({
    token: '',
  }),
  methods: {
    async redirectTo() {
      try {
        const encode = this.$route.params.token;
        const modulo = this.$route.params.modulo;
        const token = JSON.parse(window.atob(encode));

        if (window.localStorage.getItem('@vivo.consulta:UF'))
          await window.localStorage.removeItem('@vivo.consulta:UF');

        // Zera qualquer simulação de canal remanescente de um login anterior.
        window.localStorage.removeItem('canalSimulado');
        window.localStorage.setItem('revista.canal', token.canal);
        window.localStorage.setItem('revista.modulo', token.modulo);
        window.localStorage.setItem('revista.uf', token.uf);
        window.localStorage.setItem('@vivo.consulta:UF', token.uf);
        window.localStorage.setItem('access_token', token.access_token);
        setTimeout(() => {
          switch (modulo) {
            case 'revista':
              this.$router.push({ name: 'home' });
              break;
            case 'tabela':
              this.$router.push({ name: 'vivo.consulta.home' });
              break;
            default:
              this.$router.push({ name: 'home' });
              break;
          }
        }, 5000);
      } catch (e) {
        this.$router.push({ name: 'login' });
      }
    },
  },
  mounted() {
    this.redirectTo();
  },
};
</script>

<style lang="scss">
#redirect {
  -webkit-animation: color-change-2x 2s ease-in-out infinite alternate both;
  animation: color-change-2x 2s ease-in-out infinite alternate both;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  & div {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    & img {
      width: 80px;
      height: 80px;
    }
    & p {
      font-size: 26px;
      color: white;
    }
  }
}

@-webkit-keyframes color-change-2x {
  0% {
    background: #b22cff;
  }
  100% {
    background: #609;
  }
}
@keyframes color-change-2x {
  0% {
    background: #b22cff;
  }
  100% {
    background: #609;
  }
}
</style>
